// ─── Relatório Norbrasil / SABESP ────────────────────────────────────────────

function fmt(ts) {
  if (!ts) return '--';
  const d = ts.toDate ? ts.toDate() : new Date(ts);
  return d.toLocaleString('pt-BR', { dateStyle: 'short', timeStyle: 'short' });
}

export function gerarRelatorioNorbrasil(os, tecnicoNome, logoUrl, { STATUS_LABELS, CHECKLIST_PADRAO, contrato }) {
  const _c       = contrato || { numero: '11.529/25', cidade: 'São José dos Campos - SP' };
  const cor      = '#2e2b7e';   // roxo institucional Norbrasil
  const corAccent = '#4a47b2';
  const corLight  = '#eae8f8';

  const badgeMap = {
    aprovada:             '#c6f6d5;color:#276749',
    reprovada:            '#fed7d7;color:#9b2c2c',
    aguardando_validacao: '#feebc8;color:#7b341e',
    rascunho:             '#e2e8f0;color:#4a5568',
    enviada:              '#bee3f8;color:#2c5282',
  };
  const bc = badgeMap[os.status] || '#e2e8f0;color:#4a5568';

  const checklistHtml = CHECKLIST_PADRAO.map(({ id, label }) =>
    `<tr>
      <td style="padding:5px 10px;font-size:15px;">${os.checklist?.[id] ? '✅' : '✗'}</td>
      <td style="padding:5px 10px;${os.checklist?.[id] ? '' : 'text-decoration:line-through;color:#a0aec0;'}">${label}</td>
    </tr>`
  ).join('');

  const fotosHtml = (os.fotos || []).map((f) =>
    `<div style="display:inline-block;margin:8px;vertical-align:top;text-align:center;break-inside:avoid;page-break-inside:avoid;">
      <div style="width:220px;height:165px;display:flex;align-items:center;justify-content:center;background:#fff;border-radius:6px;border:1px solid #c5c3ee;overflow:hidden;">
        <img src="${f.url}" style="max-width:100%;max-height:100%;width:auto;height:auto;object-fit:contain;display:block;margin:0 auto;"/>
      </div>
      ${f.legenda ? `<div style="font-size:11px;color:#4a5568;margin-top:4px;max-width:220px;">${f.legenda}</div>` : ''}
    </div>`
  ).join('');

  // ── Cabeçalho de página reutilizável ─────────────────────────────────────
  const pageHeader = `
    <div style="display:flex;align-items:center;justify-content:space-between;
      border-bottom:2px solid ${cor};padding-bottom:8px;margin-bottom:20px;">
      <img src="${logoUrl}" style="height:40px;object-fit:contain;" alt="Norbrasil"/>
      <div style="font-size:9px;color:#718096;text-align:right;">
        Contrato ${_c.numero} — SABESP &nbsp;|&nbsp; ${_c.cidade}
      </div>
    </div>`;

  // ── PÁGINA 1: Capa ────────────────────────────────────────────────────────
  const pagina1 = `
    <div class="page capa" style="page-break-after:always;">
      <div style="display:flex;flex-direction:column;align-items:center;
        justify-content:center;min-height:85vh;text-align:center;gap:28px;">
        <img src="${logoUrl}" style="max-width:260px;max-height:160px;object-fit:contain;" alt="Norbrasil"/>
        <div style="border-top:3px solid ${cor};border-bottom:3px solid ${cor};
          padding:24px 48px;margin-top:8px;">
          <div style="font-size:13px;font-weight:700;color:#4a5568;letter-spacing:.06em;
            text-transform:uppercase;margin-bottom:16px;">
            COMPANHIA DE SANEAMENTO BÁSICO DO ESTADO DE<br/>SÃO PAULO – SABESP
          </div>
          <div style="font-size:22px;font-weight:800;color:${cor};margin-bottom:8px;">
            CONTRATO ${_c.numero.toUpperCase()}
          </div>
          <div style="font-size:15px;font-weight:600;color:${corAccent};letter-spacing:.04em;">
            LOCAL: ${_c.cidade.toUpperCase()}
          </div>
        </div>
        <div style="font-size:11px;color:#718096;margin-top:8px;">
          Relatório Técnico de Ordem de Serviço &nbsp;|&nbsp; ${new Date().toLocaleDateString('pt-BR', { month: 'long', year: 'numeric' }).toUpperCase()}
        </div>
      </div>
    </div>`;

  // ── PÁGINA 2+3+4: Introdução + Metodologia + Serviços + Dados (TUDO EM 1 PÁGINA)
  const enderecoFormatado = [os.logradouro, os.numero, os.complemento, os.bairro, os.cidade, os.uf, os.cep]
    .filter(Boolean).join(', ');

  const pagina2 = `
    <div class="page">
      ${pageHeader}
      <h2>1. Introdução</h2>
      <p>O presente Relatório Técnico integra o serviço técnico e operacional para o processo de diagnóstico das ruas inspecionadas, com vistas à identificação e análise das principais extravasões e demandas do sistema de esgoto.</p>

      <h2>2. Metodologia</h2>
      <p>A atividade de fumaça permite a identificação das interligações irregulares. A fumaça é produzida por um gerador e introduzida na tubulação através da singularidade.</p>

      <h2>3. Identificação</h2>
      <div class="grid">
        <div class="field"><div class="lbl">Nº OS</div><p>${os.numeroOS || '--'}</p></div>
        <div class="field"><div class="lbl">Cliente</div><p>${os.cliente || '--'}</p></div>
        <div class="field"><div class="lbl">Tipo de Serviço</div><p>${os.tipoServico || '--'}</p></div>
        <div class="field"><div class="lbl">Hora</div><p>${os.hora || '--'}</p></div>
      </div>

      <h2>Técnico Responsável</h2>
      <div class="field"><div class="lbl">Nome</div><p>${tecnicoNome}</p></div>

      <h2>Localização do Trecho</h2>
      <div class="grid">
        <div class="field" style="grid-column:1/-1"><div class="lbl">Endereço do Trecho</div><p>${enderecoFormatado || '--'}</p></div>
        ${os.lat && os.lng
          ? `<div class="field" style="grid-column:1/-1"><div class="lbl">Coordenadas GPS</div>
             <p>Lat: ${Number(os.lat).toFixed(6)} / Lng: ${Number(os.lng).toFixed(6)}</p></div>`
          : ''}
      </div>

      <h2>Resumo do Trecho</h2>
      <div class="stats-grid">
        <div class="stat-box">
          <div class="stat-num">${(os.fotos || []).length}</div>
          <div class="stat-lbl">Registros Fotográficos</div>
        </div>
        <div class="stat-box">
          <div class="stat-num">${os.hora || '--'}</div>
          <div class="stat-lbl">Horário Inspeção</div>
        </div>
      </div>

      <h2>Checklist</h2>
      <table><tbody>${checklistHtml}</tbody></table>

      ${os.observacoes ? `<h2>Observações</h2><p style="white-space:pre-wrap;">${os.observacoes}</p>` : ''}

      ${os.validadorNome ? `<h2>Validação</h2>
        <div class="val-box ${os.status === 'aprovada' ? 'ap-box' : 'rp-box'}">
          <strong>${os.status === 'aprovada' ? '✅ Aprovada' : '❌ Reprovada'}</strong>
          por ${os.validadorNome}${os.validadaEm ? ' em ' + fmt(os.validadaEm) : ''}
          ${os.comentarioValidacao ? '<br/><em>' + os.comentarioValidacao + '</em>' : ''}
        </div>` : ''}
    </div>`;

  // ── PÁGINA 3: Registros Fotográficos ───────────────────────────────────
  const pagina3 = `
    <div class="page" style="page-break-before:always;">
      ${pageHeader}
      ${fotosHtml
        ? `<h2>Registros Fotográficos (${(os.fotos || []).length})</h2><div>${fotosHtml}</div>`
        : '<h2>Registros Fotográficos</h2><p style="color:#a0aec0;">Nenhuma foto anexada.</p>'}
    </div>`;

  return `<!DOCTYPE html><html lang="pt-BR"><head><meta charset="UTF-8"/>
    <title>Relatório OS ${os.numeroOS || os.id.slice(-6)} — Norbrasil / SABESP</title>
    <style>
      *{box-sizing:border-box;}
      body{font-family:Arial,sans-serif;margin:0;padding:0;font-size:13px;color:#1a202c;}
      .page{padding:32px 40px;}
      .capa{padding:40px;}
      h1{font-size:20px;margin:0 0 4px;}
      h2{font-size:13px;font-weight:800;margin:0 0 12px;color:${cor};
        border-bottom:3px solid ${corLight};padding-bottom:8px;padding-top:8px;
        text-transform:uppercase;letter-spacing:.06em;}
      p{line-height:1.7;margin:0 0 10px;color:#2d3748;}
      .badge{display:inline-block;padding:3px 12px;border-radius:20px;
        font-size:11px;font-weight:700;background:${bc.split(';')[0]};}
      .grid{display:grid;grid-template-columns:1fr 1fr;gap:8px 28px;}
      .field{margin-bottom:8px;}
      .field .lbl{font-size:10px;text-transform:uppercase;font-weight:700;color:#718096;}
      .field p{margin:2px 0 0;}
      .stats-grid{display:grid;grid-template-columns:repeat(2,1fr);gap:8px;margin:8px 0;}
      .stat-box{background:#f7fafc;border:1px solid #e2e8f0;border-radius:8px;
        padding:10px 6px;text-align:center;}
      .stat-num{font-size:22px;font-weight:800;color:${cor};}
      .stat-lbl{font-size:9px;text-transform:uppercase;color:#718096;margin-top:2px;}
      table{border-collapse:collapse;width:100%;}
      td{vertical-align:middle;padding:5px 10px;}
      .page-header{background:#fff;display:flex;align-items:center;justify-content:space-between;
        padding:0 0 10px;border-bottom:2px solid ${cor};margin-bottom:14px;}
      .val-box{padding:12px;border-radius:8px;margin-top:8px;}
      .ap-box{background:#f0fff4;border:1px solid #9ae6b4;}
      .rp-box{background:#fff5f5;border:1px solid #feb2b2;}
      @media print{
        .print-actions{display:none!important;}
        .page{padding:24px 28px 24px;}
        .capa{padding:24px;}
        .page-header{padding:0 0 8px;margin-bottom:12px;}
        h2{padding-top:8px;}
      }
    </style></head><body>
    ${pagina1}
    ${pagina2}
    ${pagina3}
        🖨️ Imprimir / Salvar PDF
      </button>
    </div>
  </body></html>`;
}
